module.exports = __webpack_public_path__ + "static/img/menu3.550e8ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu3.png
// module id = Shvi
// module chunks = 0